/* American Threads Co - sticky mobile preview.
   On phones, once the product gallery has scrolled out of view while the
   shopper is still working through the options, pin a small copy of the
   current preview to the top of the screen (like trendingcustom.com).

   The panel never builds its own preview. It mirrors what the gallery shows:
     - Teeinblue products: once an option is touched, Teeinblue draws the live
       design into the gallery (gallerySelector '.product-information__media'
       in theme.liquid) as .tee-gallery-content > .tee-slider > .tee-slide,
       one slide per colour mockup: an <img> mockup with an SVG artwork on top.
       We copy the active .tee-slide only (not the colour thumbnail strip).
     - Plain Shopify products: the slide on screen is the selected variant
       image (Horizon + atc-size-select.js keep it in step with Color).
   It re-copies on every option change and whenever the gallery mutates.

   2026-10-28: Teeinblue products now use Teeinblue's official sticky gallery
   (assets/tee-sticky-gallery.js); this panel steps aside on any page with a
   Teeinblue form and only runs on plain Shopify products.

   2026-10-28: the panel sits just under the sticky header, not over it, so
   the cart icon and its count stay in sight after Add to cart (Andi does not
   want the cart drawer to pop open).

   Controls: + / - zoom (1x to 3x, drag to pan when zoomed), X closes it until
   the shopper scrolls back up to the gallery. */
(function () {
  var MOBILE = window.matchMedia('(max-width: 749px)');
  var BOX = 236;            /* preview height in px */
  var ZOOMS = [1, 1.5, 2, 3];
  var CARD = '.card, .product-card, product-card, .resource-list__item, .quick-add, dialog';

  var panel, stage, zoomIdx = 0, closed = false, shown = false;
  var source = null, liveCanvas = false, pan = { x: 0, y: 0 };
  var refreshTimer = null, canvasTimer = null, lastKey = '';

  function css() {
    if (document.getElementById('atc-stp-style')) return;
    var s = document.createElement('style');
    s.id = 'atc-stp-style';
    s.textContent = [
      '.atc-stp{position:fixed;top:0;left:0;right:0;z-index:9000;',
      'background:#fff;box-shadow:0 4px 18px rgba(0,0,0,.18);',
      'transform:translateY(-110%);transition:transform .25s ease;',
      'padding:8px 52px 8px 52px;box-sizing:border-box;}',
      '.atc-stp[data-on="0"],.atc-stp:not([data-on]){visibility:hidden;}',
      '.atc-stp[data-on="1"]{transform:translateY(0);}',
      '.atc-stp__view{position:relative;height:' + BOX + 'px;margin:0 auto;overflow:hidden;',
      'touch-action:none;background:#fff;}',
      '.atc-stp__stage{position:absolute;left:50%;top:50%;transform-origin:center center;}',
      '.atc-stp__stage img,.atc-stp__stage canvas{max-width:none;}',
      '.atc-stp__img{display:block;height:' + BOX + 'px;width:auto;}',
      '.atc-stp__x{position:absolute;top:6px;right:8px;width:36px;height:36px;border:0;',
      'background:transparent;color:#222;font-size:26px;line-height:36px;padding:0;cursor:pointer;}',
      '.atc-stp__zoom{position:absolute;right:8px;bottom:10px;display:flex;flex-direction:column;',
      'border:1px solid #d6d6d6;border-radius:6px;background:#fff;overflow:hidden;}',
      '.atc-stp__zoom button{width:38px;height:40px;border:0;background:#fff;color:#222;',
      'font-size:24px;line-height:40px;padding:0;cursor:pointer;}',
      '.atc-stp__zoom button+button{border-top:1px solid #e6e6e6;}',
      '.atc-stp__zoom button:disabled{color:#c4c4c4;cursor:default;}',
      '@media (min-width:750px){.atc-stp{display:none!important;}}'
    ].join('');
    document.head.appendChild(s);
  }

  function build() {
    if (panel) return;
    css();
    panel = document.createElement('div');
    panel.className = 'atc-stp';
    panel.setAttribute('aria-hidden', 'true');
    panel.innerHTML =
      '<div class="atc-stp__view"><div class="atc-stp__stage"></div></div>' +
      '<button type="button" class="atc-stp__x" aria-label="Close preview">&times;</button>' +
      '<div class="atc-stp__zoom">' +
      '<button type="button" data-z="1" aria-label="Zoom in">+</button>' +
      '<button type="button" data-z="-1" aria-label="Zoom out">&minus;</button></div>';
    stage = panel.querySelector('.atc-stp__stage');
    document.body.appendChild(panel);

    panel.querySelector('.atc-stp__x').addEventListener('click', function () {
      closed = true;
      hide();
    });
    panel.querySelector('.atc-stp__zoom').addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      zoomIdx = Math.max(0, Math.min(ZOOMS.length - 1, zoomIdx + Number(b.getAttribute('data-z'))));
      if (zoomIdx === 0) pan = { x: 0, y: 0 };
      applyZoom();
    });

    /* drag to pan while zoomed */
    var view = panel.querySelector('.atc-stp__view'), drag = null;
    view.addEventListener('pointerdown', function (e) {
      if (zoomIdx === 0) return;
      drag = { x: e.clientX - pan.x, y: e.clientY - pan.y };
      view.setPointerCapture(e.pointerId);
    });
    view.addEventListener('pointermove', function (e) {
      if (!drag) return;
      pan = { x: e.clientX - drag.x, y: e.clientY - drag.y };
      applyZoom();
    });
    view.addEventListener('pointerup', function () { drag = null; });
    view.addEventListener('pointercancel', function () { drag = null; });
  }

  function applyZoom() {
    var z = ZOOMS[zoomIdx];
    var base = Number(stage.getAttribute('data-fit') || 1);
    var lim = (z - 1) * BOX / 2 + 40;
    pan.x = Math.max(-lim, Math.min(lim, pan.x));
    pan.y = Math.max(-lim, Math.min(lim, pan.y));
    stage.style.transform = 'translate(-50%,-50%) translate(' + pan.x + 'px,' + pan.y + 'px) scale(' + (base * z) + ')';
    var btns = panel.querySelectorAll('.atc-stp__zoom button');
    btns[0].disabled = zoomIdx === ZOOMS.length - 1;
    btns[1].disabled = zoomIdx === 0;
  }

  /* Where the sticky header ends on screen, so the panel can sit under it.
     0 when the header has scrolled away (non-sticky or scroll-up headers). */
  function headerBottom() {
    var h = document.querySelector('header-component') || document.querySelector('#header-group, header');
    if (!h) return 0;
    var r = h.getBoundingClientRect();
    if (r.bottom <= 0 || r.top > 1 || r.height > 200) return 0;
    return Math.round(r.bottom);
  }

  /* ---------------- finding what the gallery shows ---------------- */

  function gallery() {
    var all = document.querySelectorAll('media-gallery, .product-information__media');
    for (var i = 0; i < all.length; i++) {
      if (all[i].closest(CARD)) continue;
      return all[i];
    }
    return null;
  }

  function mainForm() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].closest(CARD)) continue;
      return forms[i];
    }
    return null;
  }

  /* The slide currently on screen. Horizon's mobile gallery is a horizontal
     scroll track, so the index comes from scrollLeft (same as atc-size-select). */
  function currentSlide(g) {
    var sc = g.querySelector('slideshow-component') || g;
    var slides = sc.querySelectorAll('slideshow-slide');
    if (!slides.length) return g.querySelector('.product-media, img') ? g : null;
    var track = sc.querySelector('slideshow-slides');
    var w = slides[0].getBoundingClientRect().width || 1;
    var i = track ? Math.round(track.scrollLeft / w) : 0;
    return slides[Math.max(0, Math.min(slides.length - 1, i))];
  }

  /* Teeinblue's live slider, when it has been drawn: the slide in view.
     Slides off to the side still show loading.svg, so geometry decides. */
  function teeSlide(g) {
    var host = g.closest('.product-information__media') || g;
    var content = host.querySelector('.tee-gallery-content');
    if (!content) return null;
    var slider = content.querySelector('.tee-slider') || content;
    var slides = slider.querySelectorAll('.tee-slide');
    if (!slides.length) return null;
    var sr = slider.getBoundingClientRect();
    if (!sr.width) return null;
    var best = null, dist = Infinity;
    for (var i = 0; i < slides.length; i++) {
      var r = slides[i].getBoundingClientRect();
      if (!r.width || !r.height) continue;
      var d = Math.abs(r.left - sr.left);
      if (d < dist) { dist = d; best = slides[i]; }
    }
    return best;
  }

  function pickSource() {
    var g = gallery();
    if (!g) return null;
    return teeSlide(g) || currentSlide(g);
  }

  /* A cloned subtree loses CSS that depends on its old ancestors, so pin the
     layout-relevant computed styles inline (SVG internals are left alone). */
  var PIN = ['position', 'display', 'left', 'top', 'right', 'bottom', 'width', 'height',
    'transform', 'transform-origin', 'object-fit', 'object-position', 'z-index', 'opacity',
    'overflow', 'background-color', 'background-image', 'background-size', 'background-position'];

  function pinStyles(from, to) {
    var a = [from].concat([].slice.call(from.querySelectorAll('*')));
    var b = [to].concat([].slice.call(to.querySelectorAll('*')));
    for (var i = 0; i < a.length && i < b.length; i++) {
      if (a[i].closest('svg') && a[i].tagName.toLowerCase() !== 'svg') continue;
      var cs = getComputedStyle(a[i]), out = '';
      for (var k = 0; k < PIN.length; k++) out += PIN[k] + ':' + cs.getPropertyValue(PIN[k]) + ';';
      b[i].style.cssText += ';' + out;
    }
  }

  /* ---------------- copying it into the panel ---------------- */

  function visibleImgs(root) {
    var list = root.tagName === 'IMG' ? [root] : [].slice.call(root.querySelectorAll('img'));
    return list.filter(function (im) {
      var r = im.getBoundingClientRect();
      return r.width > 40 && r.height > 40 && getComputedStyle(im).visibility !== 'hidden';
    });
  }

  function copyCanvases(from, to) {
    var a = from.tagName === 'CANVAS' ? [from] : from.querySelectorAll('canvas');
    var b = to.tagName === 'CANVAS' ? [to] : to.querySelectorAll('canvas');
    for (var i = 0; i < a.length && i < b.length; i++) {
      try {
        b[i].width = a[i].width;
        b[i].height = a[i].height;
        b[i].getContext('2d').drawImage(a[i], 0, 0);
      } catch (e) { /* tainted canvas: leave the clone blank */ }
    }
  }

  function snapshot() {
    if (!panel) return;
    var src = pickSource();
    if (!src) return;
    source = src;

    var hasCanvas = src.tagName === 'CANVAS' || !!src.querySelector('canvas');
    var imgs = visibleImgs(src);
    var rect = src.getBoundingClientRect();
    var node, w, h;

    /* skip the rebuild when nothing visible changed (avoids flicker) */
    var key = (hasCanvas ? 'c' : '') + imgs.map(function (im) {
      return im.currentSrc || im.src;
    }).join('|') + '#' + Math.round(rect.width) + 'x' + Math.round(rect.height) + '#' + src.innerHTML;
    if (key === lastKey && stage.firstChild) return;
    lastKey = key;

    var hasSvg = [].some.call(src.querySelectorAll('svg'), function (el) {
      var r = el.getBoundingClientRect();
      return r.width > 40 && r.height > 40;
    });

    if (!hasCanvas && !hasSvg && imgs.length === 1) {
      /* plain image: use the sharpest file the browser already picked */
      var im = imgs[0];
      node = document.createElement('img');
      node.className = 'atc-stp__img';
      node.alt = im.alt || '';
      node.src = im.currentSrc || im.src;
      w = im.naturalWidth || rect.width || BOX;
      h = im.naturalHeight || rect.height || BOX;
      node.style.width = (BOX * w / h) + 'px';
      stage.setAttribute('data-fit', '1');
    } else {
      /* layered preview: clone at its on-page size, then scale to fit */
      if (!rect.width || !rect.height) return;
      node = src.cloneNode(true);
      pinStyles(src, node);
      [].forEach.call(node.querySelectorAll('[id]'), function (el) { el.removeAttribute('id'); });
      node.removeAttribute && node.removeAttribute('id');
      [].forEach.call(node.querySelectorAll('img[loading]'), function (el) { el.loading = 'eager'; });
      [].forEach.call(node.querySelectorAll('button, [role="button"], slideshow-controls'), function (el) { el.remove(); });
      node.style.cssText += ';position:relative;inset:auto;margin:0;transform:none;width:' + rect.width + 'px;height:' + rect.height + 'px;';
      copyCanvases(src, node);
      var fit = Math.min(BOX / rect.height, (window.innerWidth - 104) / rect.width);
      stage.setAttribute('data-fit', String(fit));
    }

    stage.innerHTML = '';
    stage.appendChild(node);
    applyZoom();

    liveCanvas = hasCanvas;
    if (liveCanvas && shown && !canvasTimer) {
      canvasTimer = setInterval(function () {
        if (!shown || !source || !stage.firstChild) return;
        copyCanvases(source, stage.firstChild);
      }, 500);
    }
  }

  /* Option changes: Horizon swaps the gallery ~0.9s later and Teeinblue
     redraws on its own clock, so copy a few times. */
  function refreshSoon() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      snapshot();
      setTimeout(snapshot, 700);
      setTimeout(snapshot, 1800);
      setTimeout(snapshot, 3500);
    }, 150);
  }

  /* ---------------- when to show ---------------- */

  function show() {
    if (shown) return;
    shown = true;
    snapshot();
    panel.setAttribute('data-on', '1');
    panel.setAttribute('aria-hidden', 'false');
  }

  function hide() {
    if (!panel || !shown) return;
    shown = false;
    panel.setAttribute('data-on', '0');
    panel.setAttribute('aria-hidden', 'true');
    clearInterval(canvasTimer);
    canvasTimer = null;
  }

  var ticking = false;
  function check() {
    ticking = false;
    if (!MOBILE.matches) { hide(); return; }
    /* Teeinblue products use Teeinblue's own sticky gallery (tee-sticky-gallery.js,
       Andi 2026-10-28), so this panel only serves plain Shopify products. */
    if (document.querySelector('#tee-artwork-form, .tee-form-wrapper')) { hide(); return; }
    var g = gallery(), f = mainForm();
    if (!g || !f) { hide(); return; }

    var gr = g.getBoundingClientRect();
    /* gallery back on screen: re-arm after an X */
    if (gr.bottom > 60) { closed = false; hide(); return; }
    if (closed) return;

    /* stop once the shopper is past the options and buy buttons */
    var area = f.closest('.product-details, product-form-component, .product-information__details') || f;
    var fr = area.getBoundingClientRect();
    if (fr.bottom < BOX + 80) { hide(); return; }

    build();
    var top = headerBottom() + 'px';
    if (panel.style.top !== top) panel.style.top = top;
    show();
  }

  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(check); }
  }

  function init() {
    if (!gallery()) return;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    ['change', 'input', 'click'].forEach(function (type) {
      document.addEventListener(type, function (e) {
        var t = e.target;
        if (!t || !t.closest || !shown) return;
        if (panel && panel.contains(t)) return;
        if (t.closest('form[action*="/cart/add"], variant-picker, .tee-form-wrapper, [class*="tee-"]')) refreshSoon();
      }, true);
    });

    /* the gallery itself changed (variant swap, Teeinblue redraw) */
    var mo = new MutationObserver(function (list) {
      if (!shown) return;
      for (var i = 0; i < list.length; i++) {
        var t = list[i].target;
        if (t.closest && t.closest('media-gallery, .product-information__media')) { refreshSoon(); return; }
        if (list[i].type === 'childList' && t.querySelector && t.querySelector('media-gallery')) { refreshSoon(); return; }
      }
    });
    var main = document.getElementById('MainContent') || document.body;
    mo.observe(main, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset', 'style', 'class', 'href'] });

    check();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
